/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { UserId } from "./UserId";
import { AgentId } from "./AgentId";
import { GuestId } from "./GuestId";
export const ActorIdUnion = core.serialization.undiscriminatedUnion([UserId, AgentId, GuestId]);
